import { render, staticRenderFns } from "./RegisterVisitorView.vue?vue&type=template&id=2a3de264&scoped=true&"
import script from "./RegisterVisitorView.vue?vue&type=script&lang=js&"
export * from "./RegisterVisitorView.vue?vue&type=script&lang=js&"
import style0 from "./RegisterVisitorView.vue?vue&type=style&index=0&id=2a3de264&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3de264",
  null
  
)

export default component.exports